/**
 * @mixin
 */
import TabIconBadge from './tab-icon-badge.vue';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import variantClasses from './variant-classes/tabs-variant-classes';

export default {
	components: {
		TabIconBadge
	},
	data() {
		return {
			currentTabIndex: this.selectedTabIndex
		};
	},
	props: {
		/**
		 * [
		 * 	{
		 * 		index: 1,
		 * 		title: 'Tab Title'
		 * 	}
		 * ]
		 */
		tabs: {
			type: Array,
			default: () => []
		},
		selectedTabIndex: {
			type: Number,
			default: 1
		}
	},
	mixins: [componentVariantMixin],
	computed: {},
	created() {
		this.variantClasses = variantClasses;
	},
	methods: {
		onTabClick(tabIndex) {
			this.currentTabIndex = tabIndex;
			this.$emit('tabChange', this.currentTabIndex);
		}
	}
};
